<mat-expansion-panel [expanded]="isopen">
  <mat-expansion-panel-header>
    <mat-panel-title class="item-title">
      <span class="d-inline-block w-100 fs-body-md lh-sm">{{ datatitle }}</span>
    </mat-panel-title>
  </mat-expansion-panel-header>

  <ng-content></ng-content>
</mat-expansion-panel>

<!--<mat-accordion>
  @for (item of accordeonItems; track item.id; let i = $index) {
    <mat-expansion-panel
      (opened)="openPanelIndex.set(i)"
      (closed)="openPanelIndex() === i ? openPanelIndex.set(undefined) : null"
      [ngClass]="{
        'mat-before-expanded': openPanelIndex() !== null && openPanelIndex()! - 1 === i,
        'mat-after-expanded': openPanelIndex() !== null && openPanelIndex()! + 1 === i,
      }"
    >
      <mat-expansion-panel-header>
        <mat-panel-title class="item-title">
          <span class="d-inline-block w-100 fs-body-md lh-sm">{{ item.title }}</span>
        </mat-panel-title>
      </mat-expansion-panel-header>

      @if (item.content) {
        <div
          class="markdown-content"
          fstrDynamicContent
          [innerHTML]="item.content | resizeHtmlImages | stripEmbed: cookiePreferences() | safe"
        ></div>
      }
    </mat-expansion-panel>
  }
</mat-accordion>-->
